/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Contact } from './Contact';
import type { Dictionary_unknown_ } from './Dictionary_unknown_';
import type { FunnelChannelSession } from './FunnelChannelSession';
import type { FunnelInteractionDirection } from './FunnelInteractionDirection';
import type { FunnelInteractionStatus } from './FunnelInteractionStatus';
import type { FunnelInteractionType } from './FunnelInteractionType';
import type { StatusDateFieldEntry } from './StatusDateFieldEntry';
/**
 * Interface representing a funnel conversation document
 */
export type FunnelConversationDocument = {
    createdAt: string;
    updatedAt: string;
    tenantId: string;
    /**
     * Optional array of contacts involved in this conversation
     */
    contacts?: Array<Contact>;
    /**
     * Reference to the user involved in the conversation
     */
    userId?: number | null;
    /**
     * Optional custom fields for the conversation
     */
    customFields?: Dictionary_unknown_;
    /**
     * Optional array of channel sessions associated with this conversation
     */
    channelSessions?: Array<FunnelChannelSession>;
    id: string;
    modelType: FunnelConversationDocument.modelType;
    archivedAt?: string | null;
    eventSequence?: number;
    eventTimestamp?: string;
    contactId?: string | null;
    propertyId?: string | null;
    funnelId?: string | null;
    funnelStatusId?: string | null;
    /**
     * Contains status transitions with their corresponding dates.
     */
    statusDateFields?: Array<StatusDateFieldEntry>;
    lastInteractionAt?: string;
    lastInteraction?: {
        direction?: FunnelInteractionDirection;
        status?: FunnelInteractionStatus;
        snippet?: string;
        modelType: FunnelInteractionType;
        id: string;
    };
};
export namespace FunnelConversationDocument {
    export enum modelType {
        CONVERSATION = 'Conversation',
    }
}

